import { KeyValuePair } from "../models/common/keyValuePair";

export const DAYS_OF_THE_WEEK: KeyValuePair[] =[
    {key: 6, value: 'Saturday'},
    {key: 0, value: 'Sunday'},
    {key: 1, value: 'Monday'},
    {key: 2, value: 'Tuesday'},
    {key: 3, value: 'Wednesday'},
    {key: 4, value: 'Thursday'},
    {key: 5, value: 'Friday'}
]


// WEBPACK FOOTER //
// ./src/app/contants/DAYS_OF_THE_WEEK.ts